const emojione = require('emojione');

const pattern = new RegExp(`${emojione.asciiRegexp}`, 'i');

export default pattern;